import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";
@Component({
  selector: 'app-bar-chart-never-logged-interventi',
  templateUrl: './bar-chart-never-logged-interventi.component.html',
  styleUrls: ['./bar-chart-never-logged-interventi.component.css']
})
export class BarChartNeverLoggedInterventiComponent implements OnInit {

      // per inizializzazione
      getAuthState: Observable<any>;
      getDoctorState: Observable<any>;
      isAuthenticated: boolean;
      user = null;
      errorMessage = null;
      subscription1: Subscription;
      subscription2: Subscription;
      subscription3: Subscription;
      subscription5: Subscription;
      title = "Interventi";
      destination = 'never-logged';
      // elementi che servono per il bar-chart
      canvas: any;
      ctx: any;
      myChartNeverLoggedPatients: Chart;
      // ******************************************************************************************************************
      
      // ******************************************************************************************************************
      // seguenti righe: inizializzazione dei pazienti 
      // ******************************************************************************************************************
      neverLoggedGlobalInterventi = 0;
      neverLoggedGlobalNoInterventi = 0;
      loggedGlobalInterventi = 0;
      loggedGlobalNoInterventi = 0;
      interventiGlobalPatients = 0;
      noInterventiGlobalPatients = 0;
      neverLoggedGlobalPatientsArray = [];
      loggedGlobalPatientsArray = [];
      neverLoggedPatientsGlobal = [];
      // ******************************************************************************************************************
      // bar chart dei pazienti 
      // ******************************************************************************************************************
      public barChartLabelsGlobalNeverLogged = ['NO', 'SI'];
      public barChartTypeGlobalNeverLogged = 'horizontalBar';
      public barChartLegendGlobalNeverLogged = true;
      public barChartDataGlobalNeverLogged = [
        {
          data: this.loggedGlobalPatientsArray, label: 'Accesso effettuato', backgroundColor: ['teal', 'teal'],
          hoverBackgroundColor: ['#066', '#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
        },
        {
          data: this.neverLoggedGlobalPatientsArray, label: 'Accesso non effettuato', backgroundColor: ['orangered','orangered'],
          hoverBackgroundColor: ['#cc3700', '#cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
        }];
      // paginator Inactive
      public pageSizeInactive = 5;
      public currentPageInactive = 0;
      public tasksInactive: any[];
      public totalSizeInactive = 0;
      // selezione Inactive Patients Global
      selectedInactive = false;
      patientNeverLoggedMail: string[] = [];
      checkedInactive = false;
      // hover variables of Inactive
      isActiveInactiveHovered = false;
      @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
        if (paginator) {
          paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
          paginator._intl.previousPageLabel = 'Pagina precedente';
          paginator._intl.nextPageLabel = 'Pagina successiva';
        }
      }
      // constructor
      constructor(private store: Store<AppState>,
                  private doctorService: DoctorService,
                  private snackBar: MatSnackBar) {
        this.getAuthState = this.store.select(selectAuthState);
        this.getDoctorState = this.store.select(selectDoctorState);
      }
      // ******************************************************************************************************************
      // metodo all'inizio
      ngOnInit(): void {
        this.subscription5 = this.getAuthState.subscribe((state) => {
          this.isAuthenticated = state.isAuthenticated;
          this.user = JSON.parse(localStorage.getItem('user'));
          this.errorMessage = state.errorMessage;
          this.retrieveGlobalNeverLoggedNoInterventi();
        });
      }
      ngOnDestroy(): void {
        this.subscription1.unsubscribe();
        this.subscription2.unsubscribe();
        this.subscription3.unsubscribe();
        this.subscription5.unsubscribe();
      }
      // ******************************************************************************************************************
      // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
      // e in standard e poi tutti
      // i pazienti in ogni categoria per poter calcolare gli attivi
      // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
      retrieveGlobalNeverLoggedNoInterventi() {
        this.subscription1 = this.doctorService.getNeverLoggedNoInterventiNumber().subscribe(npatients => {
          console.log("neverLogged Nointerventi: "+npatients)

          this.neverLoggedGlobalNoInterventi = parseInt(npatients.toString());
          this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalNoInterventi); // riempio vettore del bar-chart con telemedicina
          this.retrieveGlobalNeverLoggedInterventi();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }
      retrieveGlobalNeverLoggedInterventi() {
        this.subscription2 = this.doctorService.getNeverLoggedInterventiNumber().subscribe(npatients => {
          console.log("neverLogged Interventi: "+npatients)
          this.neverLoggedGlobalInterventi = parseInt(npatients.toString());
          this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalInterventi); // riempio il vettore del bar chart con standard
          this.retrieveGlobalInterventiNumber();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }
    
      retrieveGlobalInterventiNumber() {
        this.subscription3 = this.doctorService.getGlobalInterventiNumber().subscribe(num => {
          console.log(num);
          this.noInterventiGlobalPatients = num[0];
          this.interventiGlobalPatients = num[1];
          this.loggedGlobalNoInterventi = this.noInterventiGlobalPatients - this.neverLoggedGlobalNoInterventi;
          this.loggedGlobalPatientsArray.push(this.loggedGlobalNoInterventi); // riempio il vettore del bar chart con telemedicina
          this.loggedGlobalInterventi = this.interventiGlobalPatients - this.neverLoggedGlobalInterventi;
          this.loggedGlobalPatientsArray.push(this.loggedGlobalInterventi); // riempio il vettore del bar chart con standard
          this.canvasSetting();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }
     
      canvasSetting() {
          this.canvas = document.getElementById('myChartNeverLoggedInterventi') as HTMLCanvasElement;
          this.ctx = this.canvas.getContext('2d');
          this.myChartNeverLoggedPatients = new Chart(this.ctx, {
            type: this.barChartTypeGlobalNeverLogged,
            data: {
              labels: this.barChartLabelsGlobalNeverLogged,
              datasets: this.barChartDataGlobalNeverLogged,
            },
            options: {
              maintainAspectRatio: true,
              responsive: true,
              scales: {
                xAxes: [{
                  display: true,
                  stacked: false,
                  ticks: {
                    fontSize: 12,
                    fontStyle: 'bold',
                    fontFamily: 'Helvetica',
                    fontColor: '#006192'
                  }
                }],
                yAxes: [{
                  display: true,
                  stacked: false,
                  ticks: {
                    fontSize: 12,
                    fontStyle: 'bold',
                    fontFamily: 'Helvetica',
                    fontColor: '#006192'
                  }
                }],
              },
              legend: {
                display: true,
                position: 'top',
                labels: {
                  usePointStyle: true,
                  fontColor: '#006192',
                  fontSize: 18,
                  fontFamily: 'Helvetica',
                }
              },
              tooltips: {
                // content: '{pathology}: {number}',
                backgroundColor: '#1c1c1c',
                bodyFontSize: 18,
                titleFontSize: 18,
                cornerRadius: 5,
                caretPadding: 10
              },
              title: {
                display: true,
                text: "N° di utenti che hanno/non hanno effettuato l'accesso",
                fontColor: '#006192',
                fontSize: 20,
                fontFamily: 'Helvetica',
              },
              hover: {
                mode: 'nearest',
                intersect: true
              }
            }
          });
          } // dopo aver ottenuto tutti i dati creo il bar chart
        }